import React from 'react'
import "./customDialog.css"
import Ripple from "./button/ripple"
import { useNavigate } from "react-router-dom"
import APPLICATION_CONSTANTS from "../utils/property-file/customDialog.json"

const CustomDialog = () => {
  const nav = useNavigate();
  return (
    <div className="main-container row">
      <div className="container parent-div col-12">
        <div className="img-fluid mb-2">
          <i className="ri-mail-send-line"></i>
        </div>
      </div>
      <div className="custom-text col-12">
        <h1 className="text-light ">{APPLICATION_CONSTANTS.heading}</h1>
        <div className="mx-auto">
          <p>{APPLICATION_CONSTANTS.heading1}</p>
        </div>
        <button
          className="btn btn-dark text-center back-btn "
          onClick={() => nav("/")}
        >
          <Ripple duration={1000} />
          {APPLICATION_CONSTANTS.back_btn}
        </button>
      </div>
    </div>
  );
};
export default CustomDialog;
